<script>
  import icon from '@assets/carbon-berlin-icon.svg';

  // `row` puts the wordmark beside the icon instead of below it
  let { row = false, ...rest } = $props();
</script>

<style>
  div {
    width: max-content;
    text-align: center;
    font-family: var(--pico-font-family-headings);
    font-weight: 500;
    font-size: 1.75rem;
    line-height: 1;
    letter-spacing: 0.02em;

    /* Stacked: the wordmark sets the width, the icon follows it */
    img {
      display: block;
      width: 100%;
    }

    &.row {
      display: flex;
      align-items: center;
      font-size: 1.1rem;

      /* Beside the wordmark the icon takes its height instead */
      img {
        width: auto;
        height: 2.2em;
        margin-right: 0.3em;
      }
    }

    span + span {
      color: #27CED6;
    }
  }
</style>

<div class:row {...rest}>
  <img src={icon} alt="carbon.berlin" />
  <span>carbon</span><span>.berlin</span>
</div>
